import { t } from "i18next";
export const LOOP_RECORD = [
    {value:t('SELECT'),title:t('SELECT')},
    {value:'INBOUND_DATA',title:t('INBOUND_DATA')},
    {value:'GLOBAL_SEGMENT_COUNT',title:t('GLOBAL_SEGMENT_COUNT')},
    {value:'SEGMENT_COUNT',title:t('SEGMENT_COUNT')},
    {value:'VARIABLE_COLLECTION',title:t('VARIABLE_COLLECTION')},
    {value:'CUSTOM_DB_FIELD',title:t('CUSTOM_DB_FIELD')},
    {value:'STATUS_MESSAGES',title:t('STATUS_MESSAGES')},
    {value:'PROCESSING_ERRORS',title:t('PROCESSING_ERRORS')},
    {value:'TRANSLATION_ERRORS',title:t('TRANSLATION_ERRORS')},
    {value:'VALIDATION_ERRORS',title:t('VALIDATION_ERRORS')},
    {value:'RECORD_LOOP_CONTROL',title:t('RECORD_LOOP_CONTROL')},
]

/** EDI-only loop record options (997/EDI outbound): Segment/Element/Transaction Set/Functional Group Validation Errors. Shown when inbound dependency is EDI. */
export const LOOP_RECORD_EDI_OPTIONS = [
    { value: 'SEG_VAL_ERR', title: t('SEG_VAL_ERR') },
    { value: 'ELEM_VAL_ERR', title: t('ELEM_VAL_ERR') },
    { value: 'TRN_SET_VAL_ERR', title: t('TRN_SET_VAL_ERR') },
    { value: 'FNCT_GRP_VAL_ERR', title: t('FNCT_GRP_VAL_ERR') },
]
export const IB_SOURCE_NAME = [
    {value:t('INTERNAL_TOTAL_RECTYPE_COUNT'),title:t('INTERNAL_TOTAL_RECTYPE_COUNT')},
    {value:t('INTERNAL_CURRENT_RECTYPE_COUNT'),title:t('INTERNAL_CURRENT_RECTYPE_COUNT')}
]
export const SOURCE_TYPE = [
    { value: t("SELECT"), title: t("SELECT") },
    { value: "INBOUND_DATA", title: t("INBOUND_DATA") },
    { value: "OUTBOUND_ITEM", title: t("OUTBOUND_ITEM") },
    { value: "SYSTEM_ITEM", title: t("SYSTEM_ITEM") },
];

export const CONSTANT_RECORD_TYPE = {
    OUTBOUND_ITEM: [
        { value: "CUSTOM_DB_FIELD", title: t("CUSTOM_DB_FIELD") },
        { value: "PLUGIN", title: t("PLUGIN") },
        { value: "SEQUENCE", title: t("SEQUENCE") },
        { value: "VARIABLE", title: t("VARIABLE") },
        { value: "VARIABLE_COLLECTION", title: t("VARIABLE_COLLECTION") },
    ],
    SYSTEM_ITEM: [
        { value: "SYSTEM_DATA", title: t("SYSTEM_DATA") },
        { value: "SESSION_DATA", title: t("SESSION_DATA") },
        { value: "ACCOUNT_KEYS", title: t("ACCOUNT_KEYS") },
        { value: "TRADING_PARTNER_KEYS", title: t("TRADING_PARTNER_KEYS") },
        { value: "LOOP_COUNT", title: t("LOOP_COUNT") },
        { value: "GLOBAL_SEGMENT_COUNT", title: t("GLOBAL_SEGMENT_COUNT") },
        { value: "SEGMENT_COUNT", title: t("SEGMENT_COUNT") },
        { value: "STATUS_MESSAGES", title: t("STATUS_MESSAGES") },
        { value: "PROCESSING_ERRORS", title: t("PROCESSING_ERRORS") },
        { value: "TRANSLATION_ERRORS", title: t("TRANSLATION_ERRORS") },
        { value: "VALIDATION_ERRORS", title: t("VALIDATION_ERRORS") },
        { value: "SEG_VAL_ERR", title: t("SEG_VAL_ERR") },
        { value: "ELEM_VAL_ERR", title: t("ELEM_VAL_ERR") },
        { value: "TRN_SET_VAL_ERR", title: t("TRN_SET_VAL_ERR") },
        { value: "FNCT_GRP_VAL_ERR", title: t("FNCT_GRP_VAL_ERR") },
    ],
};

export const ACTIONS = [
    { value: "INDEX", title: t('INDEX') },
    { value: "COUNT", title: t('COUNT') },
    { value: "MIN", title: t('MIN') },
    { value: "MAX", title: t('MAX') },
    { value: "AVG", title: t('AVG') },
]

export const INDEX = [
    { value: "CURRENT", title: t('CURRENT') },
    { value: "FIRST", title: t('FIRST') },
    { value: "LAST", title: t('LAST') },
]


export const SYSTEM_SOURCE_NAME = {
    SYSTEM_DATA:[
        { value: t("SELECT"), title: t("SELECT") },
        { value: "ACCOUNT_NAME", title: t("ACCOUNT_NAME") },
        { value: "BRIDGEGATE_HOME", title: t("BRIDGEGATE_HOME") },
        { value: "GUID", title: t("GUID") },
        { value: "HOSTNAME", title: t("HOSTNAME") },
        { value: "IN_EDI_VERSION", title: t("IN_EDI_VERSION") },
        { value: "IN_RECORD_DELIMITER", title: t("IN_RECORD_DELIMITER") },
        { value: "IN_TEMPLATE_NAME", title: t("IN_TEMPLATE_NAME") },
        { value: "IN_TRANS_SET", title: t("IN_TRANS_SET") },
        { value: "IN_CHAR_COUNT", title: t("IN_CHAR_COUNT") },
        { value: "IN_RECORD_COUNT", title: t("IN_RECORD_COUNT") },
        { value: "IP_ADDRESS", title: t("IP_ADDRESS") },
        { value: "IS_PROCESS_INCOMPLETE", title: t("IS_PROCESS_INCOMPLETE") },
        { value: "IS_REALTIME", title: t("IS_REALTIME") },
        { value: "IS_REPROCESS", title: t("IS_REPROCESS") },
        { value: "IS_RUNNING_IN_WORKBENCH", title: t("IS_RUNNING_IN_WORKBENCH") },
        { value: "OUT_EDI_VERSION", title: t("OUT_EDI_VERSION") },
        { value: "OUT_RECORD_DELIMITER", title: t("OUT_RECORD_DELIMITER") },
        { value: "OUT_TEMPLATE_NAME", title: t("OUT_TEMPLATE_NAME") },
        { value: "OUT_TRANS_SET", title: t("OUT_TRANS_SET") },
        { value: "OUT_CHAR_COUNT", title: t("OUT_CHAR_COUNT") },
        { value: "OUT_RECORD_COUNT", title: t("OUT_RECORD_COUNT") },
        { value: "SERVER_CONFIG_ALIAS", title: t("SERVER_CONFIG_ALIAS") },
        { value: "SERVER_CONFIG_SERVER_URLS", title: t("SERVER_CONFIG_SERVER_URLS") },
        { value: "SERVER_VERSION_BUILD", title: t('SERVER_VERSION_BUILD') },
        { value: "TODAY", title: t("TODAY") },
        { value: "TOMORROW", title: t("TOMORROW") },
        { value: "TRANSACTION_ID", title: t("TRANSACTION_ID") },
        { value: "SERVER_CONFIG_SERVER_URL", title: t("SERVER_CONFIG_SERVER_URL") },
        { value: "SERVER_CONFIG_EXTERNAL_URL", title: t("SERVER_CONFIG_EXTERNAL_URL") },
        { value: "WFG_HOME", title: t("WFG_HOME") },
        { value: "WORKFLOW_GROUP_NAME", title: t("WORKFLOW_GROUP_NAME") },
        { value: "WORKFLOW_NAME", title: t("WORKFLOW_NAME") },
        { value: "XML_VERSION_TAG", title: t("XML_VERSION_TAG") },
        { value: "YESTERDAY", title: t("YESTERDAY") },
    ],
    STATUS_MESSAGES : [
        { value: t("SELECT"), title: t("SELECT") },
        { value: "MESSAGE_STRING", title: t("MESSAGE_STRING") },
    ],
    PROCESSING_ERRORS : [
        { value: t("SELECT"), title: t("SELECT") },
        { value: "ERROR_STRING", title: t("ERROR_STRING") },
    ],
    TRANSLATION_ERRORS : [
        { value: t("SELECT"), title: t("SELECT") },
        { value: "ERROR_STRING", title: t("ERROR_STRING") },
    ],
    VALIDATION_ERRORS : [
        { value: t("SELECT"), title: t("SELECT") },
        { value: "MAP_ERROR_LIST", title: t("MAP_ERROR_LIST") },
        { value: "ERROR_STRING", title: t("ERROR_STRING") },
        { value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
    ],
    SEG_VAL_ERR : [
        { value: t("SELECT"), title: t("SELECT") },
        { value: "MAP_ERROR_CODE", title: t("MAP_ERROR_CODE") },
        { value: "MAP_ERROR_LIST", title: t("MAP_ERROR_LIST") },
        { value: "ERROR_STRING", title: t("ERROR_STRING") },
        { value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
        { value: "FNCT_GRP_CTRL_NUM", title: t("FNCT_GRP_CTRL_NUM") },
        { value: "MAP_LOOP_ID", title: t("MAP_LOOP_ID") },
        { value: "MAP_SEGMENT_ID", title: t("MAP_SEGMENT_ID") },
        { value: "SEGMENT_POSITION", title: t("SEGMENT_POSITION") },
        { value: "TRAN_SET_CTRL_NUM", title: t("TRAN_SET_CTRL_NUM") },
    ],
    ELEM_VAL_ERR : [
        { value: t("SELECT"), title: t("SELECT") },
        { value: "MAP_BAD_DATA", title: t("MAP_BAD_DATA") },
        { value: "MAP_COMPONENT_NUMBER", title: t("MAP_COMPONENT_NUMBER") },
        { value: "MAP_ELEMENT_ID", title: t("MAP_ELEMENT_ID") },
        { value: "MAP_ELEMENT_NUMBER", title: t("MAP_ELEMENT_NUMBER") },
        { value: "MAP_ERROR_CODE", title: t("MAP_ERROR_CODE") },
        { value: "MAP_ERROR_LIST", title: t("MAP_ERROR_LIST") },
        { value: "ERROR_STRING", title: t("ERROR_STRING") },
        { value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
        { value: "FNCT_GRP_CTRL_NUM", title: t("FNCT_GRP_CTRL_NUM") },
        { value: "MAP_LOOP_ID", title: t("MAP_LOOP_ID") },
        { value: "MAP_REPETITION_NUMBER", title: t("MAP_REPETITION_NUMBER") },
        { value: "MAP_SEGMENT_ID", title: t("MAP_SEGMENT_ID") },
        { value: "SEGMENT_POSITION", title: t("SEGMENT_POSITION") },
        { value: "TRAN_SET_CTRL_NUM", title: t("TRAN_SET_CTRL_NUM") },
    ],
    TRN_SET_VAL_ERR : [
        { value: t("SELECT"), title: t("SELECT") },
        { value: "MAP_ERROR_LIST", title: t("MAP_ERROR_LIST") },
        { value: "ERROR_STRING", title: t("ERROR_STRING") },
        { value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
        { value: "FNCT_GRP_CTRL_NUM", title: t("FNCT_GRP_CTRL_NUM") },
        { value: "TRAN_SET_ACK_CODE", title: t("TRAN_SET_ACK_CODE") },
        { value: "TRAN_SET_CTRL_NUM", title: t("TRAN_SET_CTRL_NUM") },
        { value: "TRAN_SET_ERR_CODE_1", title: t("TRAN_SET_ERR_CODE_1") },
        { value: "TRAN_SET_ID_CODE", title: t("TRAN_SET_ID_CODE") },
        { value: "TRAN_SET_VER_REL", title: t("TRAN_SET_VER_REL") },
    ],
    FNCT_GRP_VAL_ERR : [
        { value: t("SELECT"), title: t("SELECT") },
        { value: "MAP_ERROR_LIST", title: t("MAP_ERROR_LIST") },
        { value: "ERROR_STRING", title: t("ERROR_STRING") },
        { value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
        { value: "FNCT_GRP_ACKT_CODE", title: t("FNCT_GRP_ACKT_CODE") },
        { value: "FNCT_GRP_CTRL_NUM", title: t("FNCT_GRP_CTRL_NUM") },
        { value: "FNCT_GRP_ERR_CODE_1", title: t("FNCT_GRP_ERR_CODE_1") },
        { value: "FNCT_GRP_ID_CODE", title: t("FNCT_GRP_ID_CODE") },
        { value: "FNCT_GRP_IN_APP_RECEIVER", title: t("FNCT_GRP_IN_APP_RECEIVER") },
        { value: "FNCT_GRP_IN_APP_SENDER", title: t("FNCT_GRP_IN_APP_SENDER") },
        { value: "FNCT_GRP_RELEASE_CODE", title: t("FNCT_GRP_RELEASE_CODE") },
        { value: "NUM_OF_ACPT_TRAN_SET", title: t("NUM_OF_ACPT_TRAN_SET") },
        { value: "NUM_OF_RECV_TRAN_SET", title: t("NUM_OF_RECV_TRAN_SET") },
        { value: "NUM_OF_TRAN_SET_INCLUDED", title: t("NUM_OF_TRAN_SET_INCLUDED") },
    ]

}
export const VARIABLE_COLLECTION = {
  variableAction: [
    { value: "SET", title: t("SET") },
    { value: "COUNT", title: t("COUNT") },
    { value: "SORT", title: t("SORT") },
    { value: "SORT_UNIQUE", title: t("SORT_UNIQUE") },
    { value: "UNIQUE", title: t("UNIQUE") },
    { value: "REVERSE", title: t("REVERSE") },
    { value: "RESET", title: t("RESET") },
    { value: "CONCATENATE", title: t("CONCATENATE") },
    { value: "ADD", title: t("ADD") },
    { value: "SUBTRACT", title: t("SUBTRACT") },
    { value: "MULTIPLY", title: t("MULTIPLY") },
    { value: "DIVIDE", title: t("DIVIDE") },
    { value: "ABS", title: t("ABS") },
    { value: "ACOS", title: t("ACOS") },
    { value: "ACRE_TO_HECTARE", title: t("ACRE_TO_HECTARE") },
    { value: "DATE_DIFF", title: t("DATE_DIFF") },
    { value: "ACRE_TO_SQMETER", title: t("ACRE_TO_SQMETER") },
    { value: "ASCII_TO_ENCODE_HEX", title: t("ASCII_TO_ENCODE_HEX") },
    { value: "ASIN", title: t("ASIN") },
    { value: "BASE64_TO STRING", title: t("BASE64_TO_STRING") },
    { value: "BASE64URL_TO_STRING", title: t("BASE64URL_TO_STRING") },
    { value: "CEILING", title: t("CEILING") },
    { value: "CENTIMETER_TO_INCHES", title: t("CENTIMETER_TO_INCHES") },
    { value: "CELSIUS_TO_FAHRENHEIT", title: t("CELSIUS_TO_FAHRENHEIT") },
    { value: "NUMBER_TO_CHAR", title: t("CHAR") },
    { value: "COS", title: t("COS") },
    { value: "CUBICFEET_TO_CUBICMETER", title: t("CUBICFEET_TO_CUBICMETER") },
    { value: "CUBICINCHES_TO_LITERS", title: t("CUBICINCHES_TO_LITERS") },
    { value: "CUBICMETER_TO_CUBICFEET", title: t("CUBICMETER_TO_CUBICFEET") },
    { value: "CUBICMETER_TO_CUBICYARD", title: t("CUBICMETER_TO_CUBICYARD") },
    { value: "CUBICYARD_TO_CUBICMETER", title: t("CUBICYARD_TO_CUBICMETER") },
    { value: "CUBICMETER_TO_GALLON", title: t("CUBICMETER_TO_GALLON") },
    { value: "ENCODE_HEX_TO_ASCII", title: t("ENCODE_HEX_TO_ASCII") },
    { value: "ESCAPE_XML_DATA", title: t("ESCAPE_XML_DATA") },
    { value: "FAHRENHEIT_TO_CELSIUS", title: t("FAHRENHEIT_TO_CELSIUS") },
    { value: "FEET_TO_METERS", title: t("FEET_TO_METERS") },
    { value: "FLOOR", title: t("FLOOR") },
    { value: "GALLON_TO_CUBICMETER", title: t("GALLON_TO_CUBICMETER") },
    { value: "GRAMS_TO_OUNCES", title: t("GRAMS_TO_OUNCES") },
    { value: "HECTARE_TO_ACRE", title: t("HECTARE_TO_ACRE") },
    { value: "HEXADECIMAL", title: t("HEXADECIMAL") },
    { value: "HEX_TO_DECIMAL", title: t("HEX_TO_DECIMAL") },
    { value: "INCHES_TO_CENTIMETER", title: t("INCHES_TO_CENTIMETER") },
    { value: "INCHES_TO_MM", title: t("INCHES_TO_MM") },
    { value: "KG_TO_LBS", title: t("KG_TO_LBS") },
    { value: "KM_TO_MILES", title: t("KM_TO_MILES") },
    { value: "LBS_TO_KG", title: t("LBS_TO_KG") },
    { value: "LITERS_TO_CUBICINCHES", title: t("LITERS_TO_CUBICINCHES") },
    { value: "LITERS_TO_QUARTS", title: t("LITERS_TO_QUARTS") },
    { value: "LOG", title: t("LOG") },
    { value: "LOG_10", title: t("LOG_10") },
    { value: "METERS_TO_FEET", title: t("METERS_TO_FEET") },
    { value: "METERS_TO_YARDS", title: t("METERS_TO_YARDS") },
    { value: "MILES_TO_KM", title: t("MILES_TO_KM") },
    { value: "MM_TO_INCHES", title: t("MM_TO_INCHES") },
    { value: "MODULUS", title: t("MODULUS") },
    { value: "OCTAL", title: t("OCTAL") },
    { value: "OUNCES_TO_GRAMS", title: t("OUNCES_TO_GRAMS") },
    { value: "POWER", title: t("POWER") },
    { value: "QUARTS_TO_LITERS", title: t("QUARTS_TO_LITERS") },
    { value: "ROUND", title: t("ROUND") },
    { value: "ROUND_DOWN", title: t("ROUND_DOWN") },
    { value: "ROUND_UP", title: t("ROUND_UP") },
    { value: "SIGN", title: t("SIGN") },
    { value: "SIN", title: t("SIN") },
    { value: "SQCENTIMETER_TO_SQINCHES", title: t("SQCENTIMETER_TO_SQINCHES") },
    { value: "SQFEET_TO_SQMETER", title: t("SQFEET_TO_SQMETER") },
    { value: "SQINCHES_TO_SQCENTIMETER", title: t("SQINCHES_TO_SQCENTIMETER") },
    { value: "SQMETER_TO_ACRE", title: t("SQMETER_TO_ACRE") },
    { value: "SQMETER_TO_SQFEET", title: t("SQMETER_TO_SQFEET") },
    { value: "SQMETERS_TO_SQYARDS", title: t("SQMETERS_TO_SQYARDS") },
    { value: "SQRT", title: t("SQRT") },
    { value: "SQYARDS_TO_SQMETERS", title: t("SQYARDS_TO_SQMETERS") },
    { value: "STRING_LENGTH", title: t("STRING_LENGTH") },
    { value: "STRING_TO_BASE64", title: t("STRING_TO_BASE64") },
    { value: "STRING_TO_BASE64URL", title: t("STRING_TO_BASE64URL") },
    { value: "TAN", title: t("TAN") },
    { value: "TANH", title: t("TANH") },
    { value: "TO_DEGREE", title: t("TO_DEGREE") },
    { value: "TO_RADIAN", title: t("TO_RADIAN") },
    { value: "YARDS_TO_METERS", title: t("YARDS_TO_METERS") },
    { value: "URLDECODE", title: t("URLDECODE") },
    { value: "URLENCODE", title: t("URLENCODE") },
    { value: "XML_TO_JSON", title: t("XML_TO_JSON") },
    { value: "PRETTY_PRINT_XML", title: t("PRETTY_PRINT_XML") },
    { value: "DE_IDENTIFY", title: t("DE_IDENTIFY") },
  ],
  filteredVariableAction : [
    { value: "SET", title: t("SET") },
    { value: "SORT", title: t("SORT") },
    { value: "SORT_UNIQUE", title: t("SORT_UNIQUE") },
    { value: "REVERSE", title: t("REVERSE") },
    { value: "CONCATENATE", title: t("CONCATENATE") },
    { value: "ADD", title: t("ADD") },
    { value: "SUBTRACT", title: t("SUBTRACT") },
    { value: "ABS", title: t("ABS") },
    { value: "ACOS", title: t("ACOS") },
    { value: "ACRE_TO_HECTARE", title: t("ACRE_TO_HECTARE") },
    { value: "DATE_DIFF", title: t("DATE_DIFF") },
    { value: "ACRE_TO_SQMETER", title: t("ACRE_TO_SQMETER") },
    { value: "ASCII_TO_ENCODE_HEX", title: t("ASCII_TO_ENCODE_HEX") },
    { value: "ASIN", title: t("ASIN") },
    { value: "BASE64_TO STRING", title: t("BASE64_TO_STRING") },
    { value: "BASE64URL_TO_STRING", title: t("BASE64URL_TO_STRING") },
    { value: "CEILING", title: t("CEILING") },
    { value: "CENTIMETER_TO_INCHES", title: t("CENTIMETER_TO_INCHES") },
    { value: "CELSIUS_TO_FAHRENHEIT", title: t("CELSIUS_TO_FAHRENHEIT") },
    { value: "NUMBER_TO_CHAR", title: t("CHAR") },
    { value: "COS", title: t("COS") },
    { value: "CUBICFEET_TO_CUBICMETER", title: t("CUBICFEET_TO_CUBICMETER") },
    { value: "CUBICINCHES_TO_LITERS", title: t("CUBICINCHES_TO_LITERS") },
    { value: "CUBICMETER_TO_CUBICFEET", title: t("CUBICMETER_TO_CUBICFEET") },
    { value: "CUBICMETER_TO_CUBICYARD", title: t("CUBICMETER_TO_CUBICYARD") },
    { value: "CUBICYARD_TO_CUBICMETER", title: t("CUBICYARD_TO_CUBICMETER") },
    { value: "CUBICMETER_TO_GALLON", title: t("CUBICMETER_TO_GALLON") },
    { value: "ENCODE_HEX_TO_ASCII", title: t("ENCODE_HEX_TO_ASCII") },
    { value: "ESCAPE_XML_DATA", title: t("ESCAPE_XML_DATA") },
    { value: "FAHRENHEIT_TO_CELSIUS", title: t("FAHRENHEIT_TO_CELSIUS") },
    { value: "FEET_TO_METERS", title: t("FEET_TO_METERS") },
    { value: "FLOOR", title: t("FLOOR") },
    { value: "GALLON_TO_CUBICMETER", title: t("GALLON_TO_CUBICMETER") },
    { value: "GRAMS_TO_OUNCES", title: t("GRAMS_TO_OUNCES") },
    { value: "HECTARE_TO_ACRE", title: t("HECTARE_TO_ACRE") },
    { value: "HEXADECIMAL", title: t("HEXADECIMAL") },
    { value: "HEX_TO_DECIMAL", title: t("HEX_TO_DECIMAL") },
    { value: "INCHES_TO_CENTIMETER", title: t("INCHES_TO_CENTIMETER") },
    { value: "INCHES_TO_MM", title: t("INCHES_TO_MM") },
    { value: "KG_TO_LBS", title: t("KG_TO_LBS") },
    { value: "KM_TO_MILES", title: t("KM_TO_MILES") },
    { value: "LBS_TO_KG", title: t("LBS_TO_KG") },
    { value: "LITERS_TO_CUBICINCHES", title: t("LITERS_TO_CUBICINCHES") },
    { value: "LITERS_TO_QUARTS", title: t("LITERS_TO_QUARTS") },
    { value: "LOG", title: t("LOG") },
    { value: "LOG_10", title: t("LOG_10") },
    { value: "METERS_TO_FEET", title: t("METERS_TO_FEET") },
    { value: "METERS_TO_YARDS", title: t("METERS_TO_YARDS") },
    { value: "MILES_TO_KM", title: t("MILES_TO_KM") },
    { value: "MM_TO_INCHES", title: t("MM_TO_INCHES") },
    { value: "MODULUS", title: t("MODULUS") },
    { value: "OCTAL", title: t("OCTAL") },
    { value: "OUNCES_TO_GRAMS", title: t("OUNCES_TO_GRAMS") },
    { value: "POWER", title: t("POWER") },
    { value: "QUARTS_TO_LITERS", title: t("QUARTS_TO_LITERS") },
    { value: "ROUND", title: t("ROUND") },
    { value: "ROUND_DOWN", title: t("ROUND_DOWN") },
    { value: "ROUND_UP", title: t("ROUND_UP") },
    { value: "SIGN", title: t("SIGN") },
    { value: "SIN", title: t("SIN") },
    { value: "SQCENTIMETER_TO_SQINCHES", title: t("SQCENTIMETER_TO_SQINCHES") },
    { value: "SQFEET_TO_SQMETER", title: t("SQFEET_TO_SQMETER") },
    { value: "SQINCHES_TO_SQCENTIMETER", title: t("SQINCHES_TO_SQCENTIMETER") },
    { value: "SQMETER_TO_ACRE", title: t("SQMETER_TO_ACRE") },
    { value: "SQMETER_TO_SQFEET", title: t("SQMETER_TO_SQFEET") },
    { value: "SQMETERS_TO_SQYARDS", title: t("SQMETERS_TO_SQYARDS") },
    { value: "SQRT", title: t("SQRT") },
    { value: "SQYARDS_TO_SQMETERS", title: t("SQYARDS_TO_SQMETERS") },
    { value: "STRING_LENGTH", title: t("STRING_LENGTH") },
    { value: "STRING_TO_BASE64", title: t("STRING_TO_BASE64") },
    { value: "STRING_TO_BASE64URL", title: t("STRING_TO_BASE64URL") },
    { value: "TAN", title: t("TAN") },
    { value: "TANH", title: t("TANH") },
    { value: "TO_DEGREE", title: t("TO_DEGREE") },
    { value: "TO_RADIAN", title: t("TO_RADIAN") },
    { value: "YARDS_TO_METERS", title: t("YARDS_TO_METERS") },
    { value: "URLDECODE", title: t("URLDECODE") },
    { value: "URLENCODE", title: t("URLENCODE") },
    { value: "XML_TO_JSON", title: t("XML_TO_JSON") },

  ],
  index: [
    { value: "CURRENT", title: t("CURRENT") },
    { value: "NEXT", title: t("NEXT") },
    { value: "FILL", title: t("FILL") },
    { value: "FIRST", title: t("FIRST") },
    { value: "LAST", title: t("LAST") },
    { value: "VARIABLE", title: t("VARIABLE") },
    { value: "SESSION_DATA", title: t("SESSION_DATA") },
  ],
};

export const WORKFLOW_SOURCE_RECORD_NAME = [
    { value: "SELECT", title: t("SELECT") },
    { value: "ACCOUNT_KEYS", title: t("ACCOUNT_KEYS") },
    { value: "CALL_WORKFLOW_DATA", title: t("CALL_WORKFLOW_DATA") },
    { value: "ELEM_VAL_ERR", title: t("ELEM_VAL_ERR") },
    { value: "FNCT_GRP_VAL_ERR", title: t("FNCT_GRP_VAL_ERR") },
    { value: "PLUGIN", title: t("PLUGIN") },
    { value: "PROCESSING_ERRORS", title: t("PROCESSING_ERRORS") },
    { value: "SEG_VAL_ERR", title: t("SEG_VAL_ERR") },
    { value: "SESSION_DATA", title: t("SESSION_DATA") },
    { value: "STATUS_MESSAGES", title: t("STATUS_MESSAGES") },
    { value: "SYSTEM_DATA", title: t("SYSTEM_DATA") },
    { value: "TRADING_PARTNER_KEYS", title: t("TRADING_PARTNER_KEYS") },
    { value: "TRN_SET_VAL_ERR", title: t("TRN_SET_VAL_ERR") },
    { value: "TRANSLATION_ERRORS", title: t("TRANSLATION_ERRORS") },
    { value: "ERR_VALIDATION", title: t("ERR_VALIDATION") },
]

export const WORKFLOW_SOURCE_FIELD_NAME = {
    SYSTEM_DATA:[
        { value: t("SELECT"), title: t("SELECT") },
        { value: "ACCOUNT_NAME", title: t("ACCOUNT_NAME") },
        { value: "BRIDGEGATE_HOME", title: t("BRIDGEGATE_HOME") },
        { value: "COMMUNICATION_ERROR", title: t("COMMUNICATION_ERROR") },
        { value: "GUID", title: t("GUID") },
        { value: "HOSTNAME", title: t("HOSTNAME") },
        { value: "IN_GROUP_COMP_DELIMITER", title: t("IN_GROUP_COMP_DELIMITER") },
        { value: "IN_EDI_VERSION", title: t("IN_EDI_VERSION") },
        { value: "IN_ESCAPE_DELIMITER", title: t("IN_ESCAPE_DELIMITER") },
        { value: "IN_FIELD_DELIMITER", title: t("IN_FIELD_DELIMITER") },
        { value: "IN_RECORD_DELIMITER", title: t("IN_RECORD_DELIMITER") },
        { value: "IN_REPETITION_DELIMITER", title: t("IN_REPETITION_DELIMITER") },
        { value: "IN_COMP_DELIMITER", title: t("IN_COMP_DELIMITER") },
        { value: "IN_TRANS_SET", title: t("IN_TRANS_SET") },
        { value: "IN_CHAR_COUNT", title: t("IN_CHAR_COUNT") },
        { value: "IN_RECORD_COUNT", title: t("IN_RECORD_COUNT") },
        { value: "IP_ADDRESS", title: t("IP_ADDRESS") },
        { value: "IS_PROCESS_INCOMPLETE", title: t("IS_PROCESS_INCOMPLETE") },
        { value: "IS_REALTIME", title: t("IS_REALTIME") },
        { value: "IS_REPROCESS", title: t("IS_REPROCESS") },
        { value: "IS_RUNNING_IN_WORKBENCH", title: t("IS_RUNNING_IN_WORKBENCH") },
        { value: "OUT_GROUP_COMP_DELIMITER", title: t("OUT_GROUP_COMP_DELIMITER ") },
        { value: "OUT_EDI_VERSION", title: t("OUT_EDI_VERSION") },
        { value: "OUT_ESCAPE_DELIMITER", title: t("OUT_ESCAPE_DELIMITER") },
        { value: "OUT_FIELD_DELIMITER", title: t("OUT_FIELD_DELIMITER") },
        { value: "OUT_RECORD_DELIMITER", title: t("OUT_RECORD_DELIMITER") },
        { value: "OUT_REPETITION_DELIMITER", title: t("OUT_REPETITION_DELIMITER") },
        { value: "OUT_COMP_DELIMITER", title: t("OUT_COMP_DELIMITER") },
        { value: "OUT_TRANS_SET", title: t("OUT_TRANS_SET") },
        { value: "OUT_CHAR_COUNT", title: t("OUT_CHAR_COUNT") },
        { value: "OUT_RECORD_COUNT", title: t("OUT_RECORD_COUNT") },
        { value: "PROCESSING_ERRORS", title: t("PROCESSING_ERRORS") },
        { value: "SERVER_CONFIG_ALIAS", title: t("SERVER_CONFIG_ALIAS") },
        { value: "SERVER_CONFIG_SERVER_URLS", title: t("SERVER_CONFIG_SERVER_URLS") },
        { value: "SERVER_VERSION_BUILD", title: t("SERVER_VERSION_BUILD") },
        { value: "TODAY", title: t("TODAY") },
        { value: "TOMORROW", title: t("TOMORROW") },
        { value: "TRANSACTION_ID", title: t("TRANSACTION_ID") },
        { value: "TRANSLATION_ERRORS", title: t("TRANSLATION_ERRORS") },
        { value: "VALIDATION_ERRORS", title: t("ERR_VALIDATION") },
        { value: "SERVER_CONFIG_SERVER_URL", title: t("SERVER_CONFIG_SERVER_URL") },
        { value: "SERVER_CONFIG_EXTERNAL_URL", title: t("SERVER_CONFIG_EXTERNAL_URL") },
        { value: "WFG_HOME", title: t("WFG_HOME") },
        { value: "WORKFLOW_GROUP_NAME", title: t("WORKFLOW_GROUP_NAME") },
        { value: "WORKFLOW_NAME", title: t("WORKFLOW_NAME") },
        { value: "XML_VERSION_TAG", title: t("XML_VERSION_TAG") },
        { value: "YESTERDAY", title: t("YESTERDAY") },
    ],
    PROCESSING_ERRORS: [
        { value: "MAP_ERROR_STRING", title: t("MAP_ERROR_STRING") },
    ],
    TRANSLATION_ERRORS: [
        { value: "MAP_ERROR_STRING", title: t("MAP_ERROR_STRING") },
    ],
    ERR_VALIDATION: [
        { value: "ERROR_STRING", title: t("MAP_ERROR_STRING") },
    ],
    VALIDATION_ERRORS: [
        { value: "ERROR_STRING", title: t("ERROR_STRING") },
    ],
    STATUS_MESSAGES: [
        { value: "MESSAGE_STRING", title: t("MESSAGE_STRING") },
    ],
    TRN_SET_VAL_ERR: [
        { value: "MAP_ERROR_STRING", title: t("MAP_ERROR_STRING") },
        { value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
        { value: "TRAN_SET_ACK_CODE", title: t("TRAN_SET_ACK_CODE") },
    ],
    FNCT_GRP_VAL_ERR: [
        { value: "MAP_ERROR_STRING", title: t("MAP_ERROR_STRING") },
        { value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
        { value: "FNCT_GRP_ACKT_CODE", title: t("FNCT_GRP_ACKT_CODE") },
    ],
    SEG_VAL_ERR: [
        { value: "MAP_ERROR_STRING", title: t("MAP_ERROR_STRING") },
        { value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
    ],
    ELEM_VAL_ERR: [
        { value: "MAP_ERROR_STRING", title: t("MAP_ERROR_STRING") },
        { value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
    ],
}